/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventsLookup } from '../../models/harvest-events-lookup';
import { HarvestEventsLookupDto } from '../../models/harvest-events-lookup-dto';

export interface AddHarvestEventsLookup$Params {
      body: HarvestEventsLookupDto
}

export function addHarvestEventsLookup(http: HttpClient, rootUrl: string, params: AddHarvestEventsLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventsLookup>> {
  const rb = new RequestBuilder(rootUrl, addHarvestEventsLookup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestEventsLookup>;
    })
  );
}

addHarvestEventsLookup.PATH = '/api/harvesteventslookup';
